import React, { useState } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import './FAQ.css';

const faqData = [
  {
    id: 1,
    question: "What is Quickplanners?",
    answer: "Quickplanners is an event planning platform that helps individuals and businesses plan events effortlessly — by finding trusted vendors, discovering verified venues, or choosing a full event planning service."
  },
  {
    id: 2,
    question: "How does Quickplanners work?",
    answer: "You choose how you want to plan your event:\n\n• Get Vendors – find and compare trusted event vendors\n• Get a Venue – discover verified venues that fit your needs and budget\n• Plan for Me – share your vision and let professionals handle everything\n\nYou stay in control at every step."
  },
  {
    id: 3,
    question: "What types of events can I plan on Quickplanners?",
    answer: "Quickplanners supports weddings, birthdays, private celebrations, corporate events, conferences, brand activations, and social gatherings of all sizes."
  },
  {
    id: 4,
    question: "Do I have to pay to use Quickplanners?",
    answer: "Some features require a small fee depending on the service you choose. This helps ensure genuine requests, quality matches, and a smooth experience for both clients and vendors."
  },
  {
    id: 5,
    question: "Why is there a listing or service fee?",
    answer: "Fees help us:\n\n• Prevent spam and unserious requests\n• Attract serious, professional vendors\n• Maintain the quality and reliability of the platform\n\nWhere applicable, fees are clearly shown before you proceed."
  },
  {
    id: 6,
    question: "What happens if I don't get any vendor responses?",
    answer: "If no vendor responds within the selected timeframe, your payment is returned as Quickplanners Credit, which you can use for another request at any time."
  },
  {
    id: 7,
    question: "How do you verify vendors and venues?",
    answer: "All vendors and venues go through a strict review process, including verification of business details, portfolios, past work, and customer history. We only approve professionals that meet our quality standards."
  },
  {
    id: 8,
    question: "Can I contact vendors or venues directly?",
    answer: "Yes. Once you find a vendor or venue you're interested in, you can communicate directly through the contact details provided."
  },
  {
    id: 9,
    question: "How long does it take to receive responses?",
    answer: "Response times vary by category and availability, but most users receive vendor or venue responses within a few hours to 48 hours."
  },
  {
    id: 10,
    question: "What is 'Plan for Me'?",
    answer: "Plan for Me is a full or assisted event planning service. You share your event details and preferences, and experienced planners manage coordination, vendors, timelines, and execution for you."
  },
  {
    id: 11,
    question: "Is Quickplanners only for luxury events?",
    answer: "No. While we prioritize quality and professionalism, Quickplanners is designed for anyone who values trusted service — regardless of event size or budget."
  },
  {
    id: 12,
    question: "How do vendors benefit from joining Quickplanners?",
    answer: "Vendors gain access to real client requests, verified leads, increased visibility, and tools to manage inquiries and bookings efficiently."
  },
  {
    id: 13,
    question: "How do I register as a vendor?",
    answer: "You can apply via the Register as a Vendor page. Once approved, you'll receive access to client requests and your vendor dashboard."
  },
  {
    id: 14,
    question: "Where is Quickplanners available?",
    answer: "Quickplanners currently serves Lagos, Abuja, and Port Harcourt, with plans to expand to more cities."
  },
  {
    id: 15,
    question: "How can I contact Quickplanners for support?",
    answer: "You can reach us via our contact page or email support@quickplanners.com for assistance."
  }
];

const FAQ = () => {
  const [openItems, setOpenItems] = useState({});

  const toggleItem = (id) => {
    setOpenItems(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <div className="faq-page">
      <div className="rectangle"></div>
      <Nav />
      <div className="faq-content">
        <div className="container">
          <h1 className="faq-heading">Frequently Asked Questions</h1>
          <div className="faq-list">
            {faqData.map((item) => (
              <div key={item.id} className={`faq-item ${openItems[item.id] ? 'open' : ''}`}>
                <button 
                  className="faq-question"
                  onClick={() => toggleItem(item.id)}
                >
                  {item.question}
                  <span className="faq-icon">{openItems[item.id] ? '−' : '+'}</span>
                </button>
                <div className="faq-answer">
                  {item.id === 15 ? (
                    <p>
                      You can reach us via our contact page or email{' '}
                      <a href="mailto:support@quickplanners.com" className="email-link">
                        support@quickplanners.com
                      </a>{' '}
                      for assistance.
                    </p>
                  ) : (
                    <p>{item.answer}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ;